<template>
  <div class="order-detail" :style="{ height: clientHeight + 'px' }">
    <Step :active='active' :type='type' :time='OrderDetail'/>

    <div class="info-detail-order fix">
            <ul class="title-info-detail-order">
              <li><span>基本信息</span></li>
              <li><span>收货信息</span></li>
            </ul>

            <div class="left-info-detail-order">
              <div class="h3-info-detail-order">
                <h3><i class='o-icon'  :class="[OrderDetail.status == 40 ? 'ocd' : OrderDetail.status == 30 ? '' : 'padding']"></i>订单状态：
                {{ OrderDetail.status | orderStatus}} 
                  <!-- {
                    deliveryOrderCode && (deliveryStatus == 30 && '待收货') || (deliveryStatus == 40 && '已收货') || orderStatusName
                  }
                  {
                      orderStatus == 20 && order.applyStopDelivery == 1 && <p class="btn-no-status-detail">申请终止发货</p>
                  } -->
                </h3>

                <p v-if="OrderDetail.status == 10">请耐心等待卖家安排发货。</p>

                <p v-if="OrderDetail.status == 30">本订单于 {{OrderDetail.completedTime}} 已完成交易。</p>
                <p v-if="OrderDetail.status == 40">本订单于{{OrderDetail.closeTime}}已关闭交易。(关闭原因：卖家关闭订单)</p>
                
                <p v-if="OrderDetail.status == 20">你还有 <Time :endTime='OrderDetail.timeInterval4Complete' />  来确认收货，处理超时发货单将自动确认收货。</p>
                
              </div>

              <div class="li-info-detail-order">
                  <p><label>订单编号：</label><span>{{ OrderDetail.code || '-'}}</span></p>
                  <p><label>订单总价：</label><IconJifen text="no" size="gray" :points="OrderDetail.totalPrice" /></p>
                  <p><label>支付方式：</label><span>{{ OrderDetail.paymentType == 10 && '积分兑换' || '-'}}</span></p>
                  <p><label>下单方式：</label><span>{{ OrderDetail.type == 10 ? '网站订单' : OrderDetail.type ==  20 ? '手机订单' : ' -'}}</span></p>
                  <p><label>发货备注：</label><span>{{ OrderDetail.remark ? OrderDetail.remark : ' -'}}</span></p>
              
              </div>
              

            </div>

            <div class="right-info-detail-order">
              <div class="li-info-detail-order info-margin">
                <p><label>店铺名称：</label><span><i class="icons icon-shop"></i><b>{{OrderDetail.vendorName}}</b></span></p>

                <div>
                    <p><label>收货人信息：</label><span><b>{{ OrderDetail.consignee || '无' }}</b><b>{{'，' + ( OrderDetail.phone || '无')}}</b></span></p>
                    <p><label>收货地址：</label><span class="w-s-b">{{ OrderDetail.address ||' -'}}</span></p>
                    <p><label>订单留言：</label><span class="w-s-b">{{ OrderDetail.memo || ' -'}}</span></p>
                </div>
              </div>

              <div class="info-margin-br"></div>

                <div class="li-info-detail-order info-margin">
                  

                  <p><label>下单时间：</label><span>{{ OrderDetail.orderTime || ' -'}}</span></p>
                  <p><label>兑换时间：</label><span><b>{{ OrderDetail.payTime || ' -'}}</b><b class="on-pay-list" @click="showPay = true"><a>兑换明细</a></b></span></p>

                  <p v-if="OrderDetail.status == 40"><label>关闭时间：</label><span>{{ OrderDetail.closeTime || ' -'}}</span></p>

                  <p v-if="OrderDetail.status == 20 || OrderDetail.status == 30"><label>发货时间：</label><span>{{ OrderDetail.deliveryTime || ' -'}}</span></p>
                  <p v-if="OrderDetail.status == 30"><label>完成时间：</label><span>{{ OrderDetail.completedTime || ' -'}}</span></p>
                </div>
              
            </div>
          </div>




    <table class="m-order-goods">
      <thead>
        <tr>
          <th class="first ac">礼品信息</th>
          <th class="ar" width="160">兑换积分</th>
          <th class="ar" width="160">数量</th>
          <th class="ac" width="200">操作</th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="(v,idxs) in OrderDetail.entries" :key="idxs">
          <td class="goods">
            <router-link  class='item fix' :to="{ path: `/product/${OrderDetail.vendorCode}/${v.productCode}` }">
              <div class="pic">
                <img v-if="v.imageUrl" :src='v.imageUrl' />
                <img v-else src='../../assets/no-picture.png' :title="v.productName"/>
              </div>
              <div class="desc">
                <p class="title w-s-b">{{v.productName}}</p>
                <p class="sub">礼品编号：{{v.productCode}}&nbsp;&nbsp;售价单位：{{v.saleUnit}}</p>
              </div>
            </router-link>
          </td>
          <td>
            <div class="price ar">
              <p><IconJifen text="no" size="gray" :points="v.price" /></p>
            </div>
          </td>
          <td><div class="num ar"><p>x{{v.quantity}}</p></div></td>
          <td><p class="on-b-add ac" @click="onBatchAdd(v)">再次兑换</p></td>
        </tr>
      </tbody>
      <tfoot>
        <tr>
          <th></th>
          <td colSpan="3">
            <div class='o-detail-total'>
              <p><span>礼品合计：</span><span><IconJifen text="no" size="gray" :points="OrderDetail.totalPrice" /></span></p>
              <p><span>订单总价：</span><span class="price"><IconJifen text="no" size="mini" :points="OrderDetail.totalPrice" /></span></p>
              <p class="o-detail-p"></p>
              <p>
                <span>兑换积分：</span>
                <span v-if="OrderDetail.paidPointDetail"><IconJifen text="no" size="gray" :points="OrderDetail.paidPointDetail.points" /></span>
                <span class="on-pay-list" @click="showPay = true"><a>兑换明细</a></span>
              </p>
              <p>
                <span>退还积分：</span>
                <template v-if="OrderDetail.status == 40 && OrderDetail.refundedPointDetail">
                  <span><IconJifen text="no" size="gray" :points="OrderDetail.refundedPointDetail.points" /></span>
                  <span class="on-pay-list" @click="refundedPay = true"><a>退还明细</a></span>
                </template>
                <span v-else>-</span>
              </p>
            </div> 
          </td>
        </tr>
      </tfoot>
    </table>

    <p  v-if="OrderDetail.status == 20" class="o-detail-btn"><z-button @click='onOk(OrderDetail.id)'>确认收货</z-button></p>
    <p class="o-detail-btn"><z-button @click="onBatchAdd('two')">再次兑换</z-button></p>

    <message-box title="兑换明细" size="confirm" okText="确定" @confirmok="confirmok" @close="showPay = false" :show="showPay">
      <div class="pay-box" v-if="OrderDetail.paidPointDetail">
        <p>交易编号：{{OrderDetail.paidPointDetail.serialNo}}</p>
        <p>交易方式：{{OrderDetail.paidPointDetail.integralTypeName}}</p>
        <p>交易时间：{{OrderDetail.paidPointDetail.createtime}}</p>
        <p>交易积分：<IconJifen text="no" size="gray" :points="OrderDetail.paidPointDetail.points" /></p>
      </div>
      <z-button size="icon-query" @click="showPay = false">确定</z-button>
    </message-box>

    <message-box title="退还明细" size="confirm" okText="确定" @confirmok="confirmok" @close="refundedPay = false" :show="refundedPay">
      <div class="pay-box" v-if="OrderDetail.refundedPointDetail">
        <p>交易编号：{{OrderDetail.refundedPointDetail.serialNo}}</p>
        <p>交易方式：{{OrderDetail.refundedPointDetail.integralTypeName}}</p>
        <p>交易时间：{{OrderDetail.refundedPointDetail.createtime}}</p>
        <p>交易积分：<IconJifen text="no" size="gray" :points="OrderDetail.refundedPointDetail.points" /></p>
      </div>
      <z-button size="icon-query" @click="refundedPay = false">确定</z-button>
    </message-box>

    <confirm titleTig="再次兑换" okText="去结算" :noCloseTag='noCloseTag' closeText='知道了' :message='message' @confirmok="confirmok" :shows="show"></confirm>
    <confirm titleTig="确认收货" okText="确定" :noCloseTag='noCloseTag' :message='message' @confirmok="onOkTig" :shows="showOk"></confirm>
  </div>
</template>
<script>
import { mapGetters } from "vuex";
import Step from "../../components/steps.vue";
import IconJifen from "../../components/icon-jifen";
import Confirm from "../../components/confirm/main.vue";
import ZButton from "../../components/zButton";
import MessageBox from "../../components/message-box";
import Time from "../../components/time";

export default {
  computed: {
    ...mapGetters(["OrderDetail","clientHeight"])
  },
  components: {
    Step,
    IconJifen,
    Confirm,
    ZButton,
    MessageBox,
    Time
  },
  data() {
    return {
      active: 0,
      type: "a",
      noCloseTag: true,
      show: false,
      showOk: false,
      showPay: false,
      refundedPay: false,
      message: "",
      opens: true
    };
  },
  watch: {
    "OrderDetail.status": function(val) {
      let self = this;
      switch (Number(val)) {
        case 10:
          // 10：待发货
          self.active = 1;
          self.type = "a";
          break;
        case 20:
          // 20：待收货
          self.active = 2;
          self.type = "a";
          break;
        case 30:
          // 30：已完成
          self.active = 4;
          self.type = "a";
          break;
        case 40:
          // 40：已关闭
          self.active = 5;
          self.type = "a";
          break;
      }
    }
  },
  created() {
    this.getDetail(this.$route.params.id);
  },
  methods: {
    getDetail(id) {
      this.$store.dispatch("GETORDERDETAIL", id);
    },
    confirmok(o) {
      this.show = false;
      if(o){
        this.$router.replace({ path: `/${this.OrderDetail.vendorCode}?open=1`});
      }
    },
    onOk(id) {
      this.showOk = true;
      this.message = `请确认是否收到货？确认收货后无法更改。`;
      this.okId = id;
    },
    onBatchAdd(o) {
      var item = o == "two" ? this.OrderDetail : o;
      var self = this;
      if (self.opens == false) return;
      self.opens = false;
      self.$store
        .dispatch("BATCH_ADD", {
          merchantCode: this.OrderDetail.vendorCode,
          cartDetails:
            o == "two"
              ? item.entries.map(v => {
                  return { quantity: v.quantity, productCode: v.productCode };
                })
              : [{ quantity: o.quantity, productCode: o.productCode }]
        })
        .then(r => {
          self.opens = true;
          if (r.data.recode == 200) {
            self.show = true;
            self.message =
              o == "two"
                ? `订单(${this.OrderDetail.code})里所有礼品已添加到兑换清单。已失效礼品无法结算。`
                : `礼品（${o.productName}）已添加到兑换清单。已失效礼品无法结算。`;
          } else {
            this.$alert(r.data.msg || '错误：' + r.data.recode, '提示')
          }
        });
    },

    onOkTig(o) {
      this.showOk = false;
      var self = this;
      if (self.open == false) return;
      self.open = false;
      if(o){
        self.$store.dispatch("ORDER_OK", this.okId).then(r => {
          self.open = true;
          if (r.data.recode == 200) {
            self.$store.dispatch("GETORDERDETAIL", self.$route.params.id);
          }
        });
      }
    }
  }
};
</script>
<style>
.order-detail {
  padding: 30px 20px 20px;
  width: 1140px;
  margin: auto;
  overflow-y: auto;
}
.pay-box {
  padding: 18px 0;
  text-align: left;
  margin-left: 60px;
  line-height: 24px;
}
/* 基本信息 */
.info-detail-order {
  text-align: left;
  min-height: 320px;
  border: 1px solid #e5e5e5;
  margin: 0 auto;
}
.title-info-detail-order {
  width: 100%;
  height: 36px;
  background-color: #f8f8f8;
  border-bottom: 1px solid #e5e5e5;
}
.title-info-detail-order li {
  float: left;
  width: 50%;
  line-height: 36px;
  border-right: 1px solid #e5e5e5;
  margin-right: -1px;
}
.title-info-detail-order li span {
  padding-left: 10px;
}
.left-info-detail-order {
  float: left;
  width: 50%;
  border-right: 1px solid #e5e5e5;
  min-height: 283px;
}
.h3-info-detail-order {
  margin: 15px 5px 10px 70px;
}

.h3-info-detail-order h3 {
  font-size: 16px;
  height: 44px;
  line-height: 44px;
}
.h3-info-detail-order h3 i {
  width: 32px;
  height: 32px;
  background-position: -26px -251px;
  display: inline-block;
  vertical-align: middle;
  margin: -3px 6px 0 -36px;
}
.h3-info-detail-order h3 i.padding {
  background-position: -92px -251px;
}
.h3-info-detail-order h3 i.ocd {
  background-position: -59px -251px;
}
.li-info-detail-order {
  margin: 20px 0 20px 70px;
}
.li-info-detail-order p {
  margin-bottom: 4px;
}
.li-info-detail-order label {
  color: #999;
  /* width: 62px; */
  display: inline-block;
}

.li-info-detail-order span {
  word-wrap: break-word;
  display: inline-block;
  width: 308px;
  vertical-align: top;
}
.li-info-detail-order span b {
  font-weight: initial;
}
.on-pay-list {
  margin-left: 20px;
  cursor: pointer;
}
.on-pay-list a:hover {
  color: #169bd5;
}
.right-info-detail-order {
  float: left;
  border-left: 1px solid #e5e5e5;
  margin-left: -1px;
  width: 49%;
}
.on-b-add {
  cursor: pointer;
}
.on-b-add:hover {
  color: #169bd5;
}
.info-margin {
  margin: 25px 0 20px 30px;
}
.info-margin label {
  width: 86px;
  text-align: right;
}
.info-margin-br {
  border-top: 1px solid #e5e5e5;
  width: 90%;
  margin: 25px 0 0 38px;
}
.info-margin b {
  font-weight: normal;
  width: normal;
}
.info-margin b span {
  width: auto !important;
}

.o-detail-total {
  width: 400px;
  text-align: left;
  overflow: hidden;
  padding-right: 11px;
  float: right;
  margin-right: 10px;
}
.o-detail-total.o-w-t {
  width: 400px;
}
.o-detail-total p {
  margin-right: 10px;
}
.o-detail-total span {
  display: inline-block;
  text-align: right;
}
.o-detail-total span:nth-child(1) {
  width: 90px;
  line-height: 24px;
}
.o-detail-total span:nth-child(2) {
  /* width: 120px; */
}
.o-detail-total span:nth-child(3) {
  width: 160px;
}
.o-detail-p {
  border-bottom: 1px solid #e5e5e5;
  margin: 10px 0;
  height: 1px;
  width: 390px;
}
.o-detail-btn {
  float: right;
  margin: 0 0 20px 10px;
}
.is-pay-btn-dad {
  background-color: rgba(255, 244, 245, 1);
  width: 110px;
  height: 46px;
  font-size: 12px;
  outline: none;
  border: 1px solid;
  color: #ff0000;
  cursor: not-allowed;
  background-image: none;
  border-color: #ff0000;
  padding: 0 10px;
}
.m-order-goods {
  margin: 20px 0;
}

.m-order-goods thead.hidden th {
  overflow: hidden;
  font-size: 0;
  padding: 0 10px;
  height: 0;
  line-height: 0;
  border: none;
}

.m-order-goods thead {
  background-color: #fff;
  color: #999;
}

.m-order-goods thead th.first {
  text-indent: 10px;
}

.m-order-goods th,
.m-order-goods td {
  line-height: 18px;
  padding: 15px 0;
}

.m-order-goods td {
  border-right: 1px solid #e7e7e7;
  vertical-align: top;
}

.m-order-goods td {
  border-right: none;
}
.m-order-goods th {
  font-weight: initial;
  background-color: #f8f8f8;
}

.m-order-goods tfoot {
  background-color: #f8f8f8;
  text-align: left;
}

.m-order-goods tfoot .price {
  font-size: 16px;
  color: #ee8c3a;
}

.m-order-goods tfoot th {
  text-align: left;
  padding: 35px 20px;
  font-weight: normal;
}

.m-order-goods tfoot td {
  text-align: left;
  padding-left: 60px;
}

.m-order-goods tr.title td {
  text-align: left;
  border-bottom: none;
}

.m-order-goods tr.title td.first {
  background-color: #f8f8f8;
  border-bottom: 1px solid #e7e7e7;
  text-indent: 10px;
}

.m-order-goods td.no-border {
  border-right: none;
}

.m-order-goods .m-button {
  width: 90px;
  margin-bottom: 5px;
  cursor: pointer;
  padding: 0 6px;
}

.m-order-goods .countdown {
  margin-bottom: 7px;
}

.m-order-goods [name="cancel-order"] {
  cursor: pointer;
}

.m-order-goods .goods {
  text-align: left;
  padding: 0;
}

.m-order-goods .goods .item {
  margin-top: -1px;
  display: block;
  border-top: 1px solid #e7e7e7;
  padding: 15px 10px 15px 20px;
  overflow: hidden;
}

.m-order-goods .goods .item .pic {
  position: relative;
  width: 80px;
  height: 80px;
  float: left;
}

.m-order-goods .goods .item .pic .done {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 3px 0;
  text-align: center;
  background-color: rgba(0, 0, 0, 0.5);
  color: #fff;
  border: 1px solid transparent;
}

.m-order-goods td,
.m-order-goods th {
  border-bottom: 1px solid #e7e7e7;
}

.m-order-goods .goods .item .pic .not-traded {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 3px 0;
  text-align: center;
  background-color: rgba(255, 255, 255, 0.5);
  color: #8c8c8c;
  border: 1px solid #ddd;
}

.m-order-goods .goods .item .pic .wait {
  position: absolute;
  left: 0;
  right: 0;
  bottom: 0;
  padding: 3px 0;
  text-align: center;
  background-color: rgba(255, 79, 62, 0.8);
  color: #fff;
  border: 1px solid transparent;
}

.m-order-goods .goods .item .pic img {
  width: 100%;
  height: 100%;
}

.m-order-goods .goods .item .desc {
  margin-left: 8px;
  width: 480px;
  float: left;
}

.m-order-goods .goods .item .desc .title {
  margin-bottom: 8px;
}

.m-order-goods .goods .item .desc .sub {
  color: #999;
}
</style>
